import socketIOClient from "socket.io-client";

import bindSocket from "./socket.on";

import { SOCKET_ENDPOINT } from "../../config";

const LOG = (...arg) => console.log("%%% SOCKET MANAGER %%% ", ...arg);

const SocketManager = class {
  initialize() {
    this.socket = socketIOClient(SOCKET_ENDPOINT, {
      path: "/socket.io",
      transports: ["websocket"],
      secure: true,
    });
    bindSocket(this);
  }

  constructor() {
    this.uiStateSetter = null;
    this.socket = null;
    this.chatHandler = null;
    this.refreshHandler = null;
    this.state = {
      user: { email: "", username: "" },
      room: { id: "", name: "" },
      isJoined: false,
    };
  }

  onSetState = () => {
    if (this.uiStateSetter) this.uiStateSetter(this.state);
  };
  debounce = (func, delay) => {
    let debounceTimer;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(context, args), delay);
    };
  };
  newStateCaller = this.debounce(this.onSetState, 100);

  setState(newState) {
    // merge changes with current state
    this.state = { ...this.state, ...newState };
    LOG("setstate", this.state);
    this.newStateCaller();
  }

  getState() {
    return this.state;
  }

  register([stateManager, addChat]) {
    this.uiStateSetter = stateManager;
    this.chatHandler = addChat;
  }

  setRefreshHandler(refreshHandler) {
    this.refreshHandler = refreshHandler;
  }

  emitter({ method, data }) {
    if (this.socket)
      this.socket.emit(method, {
        user: this.state.user,
        room: this.state.room,
        data,
      });
  }

  sync({ username, email, roomId, roomName }) {
    this.state.user = { username, email };
    this.state.room = { id: roomId, name: roomName };
    this.state.isJoined = true;
    this.initialize();
    setTimeout(() => {
      this.emitter({ method: "reset" });
      this.setState({});
    }, 300);
  }

  leave() {
    this.emitter({ method: "leave" });
    setTimeout(() => {
      this.state.isJoined = false;
      this.state.user = {};
      this.state.room = {};
      this.setState({});
    }, 500);
  }

  play(idx) {
    this.emitter({ method: "play", data: idx });
  }
  pause() {
    this.emitter({ method: "pause" });
  }
  next() {
    this.emitter({ method: "next" });
  }
  prev() {
    this.emitter({ method: "prev" });
  }
  resume() {
    this.emitter({ method: "resume" });
  }
  seek(seekTo) {
    this.emitter({ method: "seek", data: seekTo });
  }
  chat(msg) {
    this.emitter({ method: "chat", data: msg });
  }
  refresh(type) {
    this.emitter({ method: "refresh", data: type });
  }
  remove(idx) {
    this.emitter({ method: "remove", data: idx });
  }
};

const instance = new SocketManager();

export default instance;
